export const UnsupportedAudioMimeTypes = new Set([
    'audio/amr',
]);